var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { attrs: { action: _vm.action, autocomplete: "on", method: "post" } },
    [
      _c("LoginTextField", {
        attrs: {
          autoFocus: _vm.autofocus === "email",
          label: "Email",
          name: "email",
          placeholder: _vm.emailPlaceholder,
          required: "",
          submitOnEnter: _vm.submit,
          type: "email",
          vvName: "email",
        },
        on: {
          focus: function ($event) {
            return _vm.updateAutofocus("email")
          },
        },
        model: {
          value: _vm.form.email,
          callback: function ($$v) {
            _vm.$set(_vm.form, "email", $$v)
          },
          expression: "form.email",
        },
      }),
      _vm._v(" "),
      _c("LoginTextField", {
        attrs: {
          autoFocus: _vm.autofocus === "password",
          autocomplete: false,
          label: "Password",
          name: "password",
          placeholder: "Password",
          required: "",
          submitOnEnter: _vm.submit,
          type: "password",
          vvName: "password",
        },
        on: {
          focus: function ($event) {
            return _vm.updateAutofocus("password")
          },
        },
        model: {
          value: _vm.form.password,
          callback: function ($$v) {
            _vm.$set(_vm.form, "password", $$v)
          },
          expression: "form.password",
        },
      }),
      _vm._v(" "),
      _vm.token
        ? _c("input", {
            attrs: { name: _vm.token.name, type: "hidden" },
            domProps: { value: _vm.token.value },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "LoginActionButton",
        {
          attrs: {
            action: _vm.submit,
            "data-automation": "loginButton",
            isLoading: _vm.isLoading,
            type: "submit",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.submitButtonText) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }